import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

const newsletterMobile = {
  id: 'newsletter-mobile',
  componentType: 'newsletterMobile',
  condition: (options) => injectionHelpers.shouldInjectSubscriptionOrNewsletter({ options, viewport: 'mobile', component: 'newsletter' }),
  component: ({
    newsletterConfig, breakpoints, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'newsletter-mobile',
    props: { newsletterConfig, breakpoints, viewport: 'mobile' },
    defaultConfig: config.getNewsletterConfig({ newsletterConfig, breakpoints, viewport: 'mobile' }),
  }),
  resetCurrentItemTypeCurrentCounter: false,
};

const newsletterDesktop = {
  id: 'newsletter-desktop',
  componentType: 'newsletterDesktop',
  condition: (options) => injectionHelpers.shouldInjectSubscriptionOrNewsletter({ options, viewport: 'desktop', component: 'newsletter' }),
  component: ({
    newsletterConfig, breakpoints, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'newsletter-desktop',
    props: { newsletterConfig, breakpoints, viewport: 'desktop' },
    defaultConfig: config.getNewsletterConfig({ newsletterConfig, breakpoints, viewport: 'desktop' }),
  }),
  resetCurrentItemTypeCurrentCounter: false,
};

export default [
  newsletterMobile,
  newsletterDesktop,
];
